import type { IconSvgObject } from './types';

const Search02Icon: IconSvgObject = [
  ["path", { d: "M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20.4697 21.5303C20.7626 21.8232 21.2374 21.8232 21.5303 21.5303C21.8232 21.2374 21.8232 20.7626 21.5303 20.4697L21 21L20.4697 21.5303ZM15 15L14.4697 15.5303L20.4697 21.5303L21 21L21.5303 20.4697L15.5303 14.4697L15 15Z", fill: "currentColor", key: "1" }]
];

export default Search02Icon;
